import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {LangChange} from "../../../../lang-change";
import {Language} from "../../../../common/models/language";
import {TranslateService} from '@ngx-translate/core';
import {NewsSharedService} from "../../../common-main/services/news-shared.service";
import {Router} from '@angular/router';
import {NewsTag} from "./model/news-tag";
import {Utils} from "../../../../common/services/Utils";

@Component({
  selector: 'app-news-tags-list',
  templateUrl: './news-tags-list.component.html',
  styleUrls: ['./news-tags-list.component.scss']
})
export class NewsTagsListComponent extends LangChange implements OnInit {
  allTagsList: NewsTag[] = [];
  tagsList: NewsTag[] = [];

  @Input() tagId: number;
  @Output() valueChange = new EventEmitter();

  constructor(private router: Router,
              private newsSharedService: NewsSharedService,
              private utils: Utils) {
    super(utils._translateService);
  }

  ngOnInit() {
    this.loadTagsList().then((value) => {
      this.getTagsList(this.utils._translateService.currentLang);
    }, reason => {
      this.utils.notifyError(this.utils._translateService.instant("tags_load_error"), "");
    });
  }

  onLangChange(language: Language): void {
    this.getTagsList(language.code);
  }

  loadTagsList() {
    return new Promise((resolve, reject) => {
      this.newsSharedService.getTagsList().subscribe(data => {
        if (data) {
          this.allTagsList = data;
          resolve();
        }
      }, error => {
        reject(error.toString());
      });
    });
  }

  getTagsList(lang: string) {
    if (this.allTagsList) {
      this.tagsList = [];
      this.allTagsList.forEach(x => {
        if (x.lang === lang) {
          this.tagsList.push(x);
        }
      });
    }
  }

  getNewsByTagId(tag) {
    if (tag.id === this.tagId) {
      this.resetFilter();
      return;
    }
    if (tag.id) {
      this.router.navigate(['/news/tag/' + tag.id]);
    }
  }

  resetFilter() {
    this.router.navigate(['/news/']);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/news-tags-list/news-tags-list.component.ts